import axios from "axios";
import { IEmailTemplate, IMergeField, TemplateType } from "../types/IEmailTemplate";

const BASE_URL = `${process.env.REACT_APP_SERVER_URL}/api/v1/communications`;

export const getTemplates = async (): Promise<IEmailTemplate[]> => {
  const response = await axios.get(`${BASE_URL}/templates`);
  return response.data.data;
};

export const getTemplate = async (id: string): Promise<IEmailTemplate> => {
  const response = await axios.get(`${BASE_URL}/templates/${id}`);
  return response.data.data;
};

export const createTemplate = async (data: {
  templateType?: TemplateType;
  name: string;
  subject?: string;
  designJson?: Record<string, unknown>;
  htmlContent?: string;
  messageText?: string;
}): Promise<IEmailTemplate> => {
  const response = await axios.post(`${BASE_URL}/templates`, data);
  return response.data.data;
};

export const updateTemplate = async (
  id: string,
  data: Partial<{
    name: string;
    subject: string;
    designJson: Record<string, unknown>;
    htmlContent: string;
    messageText: string;
  }>
): Promise<IEmailTemplate> => {
  const response = await axios.put(`${BASE_URL}/templates/${id}`, data);
  return response.data.data;
};

export const deleteTemplate = async (id: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/templates/${id}`);
};

export const cloneTemplate = async (id: string): Promise<IEmailTemplate> => {
  const response = await axios.post(`${BASE_URL}/templates/${id}/clone`);
  return response.data.data;
};

export const getMergeFields = async (
  channel?: string
): Promise<IMergeField[]> => {
  const response = await axios.get(`${BASE_URL}/merge-fields`, {
    params: channel ? { channel } : undefined,
  });
  return response.data.data;
};
